'use strict'

$ = require 'jquery'
_ = require 'underscore'

bcLoad = ->
  if document.head.getAttribute("data-app") is "itier-glive-checkout"
    window.Groupon.Performance.pageReady()
  Backbone = require "backbone"
  Backbone._ = _
  Backbone.$ = $
  require "../../modules/glive_booking_redesign/frontend"

if document.readyState is "complete"
  bcLoad()
else if window.addEventListener
  window.addEventListener 'load', bcLoad, false
else if window.attachEvent
  window.attachEvent 'onload', bcLoad
else
  prevOnload = window.onload
  window.onload = ->
    prevOnload() if prevOnload
    bcLoad()
